(function () {
  'use strict';
  if (window.IWAnalytics && typeof window.IWAnalytics.track === 'function') return;

  var configNode = document.getElementById('iwobblDesignerApp');
  var config = configNode && configNode.dataset ? configNode.dataset : {};
  var GA4_ID = config.ga4Id || '';
  var TIMELINE_URL = config.timelineUrl || '/apps/design/api/analytics/events';
  var DEBUG = /[?&]iwa_debug=1/.test(location.search) ||
    (function () {
      try { return localStorage.getItem('iwa_debug') === '1'; }
      catch (e) { return false; }
    })();
  var P = {
    schema_version: 1,
    page_type: 'designer',
    page_handle: 'design',
    currency: config.currency || 'USD',
    device_type: window.matchMedia && window.matchMedia('(max-width: 767px)').matches
      ? 'mobile'
      : 'desktop',
    customer_state: config.customerState || 'guest'
  };
  var timelineQueue = [];
  var timelineTimer = 0;
  var timelineSequence = 0;
  var boundDesignId = '';
  var timelineJourneyId = '';
  var timelinePageInstanceId = '';

  function makeId(prefix) {
    return prefix + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
  }

  try {
    P.designer_session_id = sessionStorage.getItem('iwa_designer_session');
    if (!P.designer_session_id) {
      P.designer_session_id = makeId('ds_');
      sessionStorage.setItem('iwa_designer_session', P.designer_session_id);
    }
    timelineJourneyId = sessionStorage.getItem('iwa_journey_id');
    if (!timelineJourneyId) {
      timelineJourneyId = makeId('jy_');
      sessionStorage.setItem('iwa_journey_id', timelineJourneyId);
    }
  } catch (e) {
    P.designer_session_id = makeId('ds_');
    timelineJourneyId = makeId('jy_');
  }
  timelinePageInstanceId = makeId('pi_');

  function consentOK() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') {
        return cp.analyticsProcessingAllowed();
      }
    } catch (e) {}
    return true;
  }

  function loadGtag() {
    if (!GA4_ID || !consentOK() || window.__iwaGtagLoaded) return;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    window.__iwaGtagLoaded = true;
    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + GA4_ID;
    document.head.appendChild(script);
    window.gtag('js', new Date());
    window.gtag('config', GA4_ID, { send_page_view: false });
  }

  function timelineParams(payload) {
    var out = {};
    Object.keys(payload || {}).forEach(function (key) {
      if (/email|phone|name|address|visitor_token|guest_token|custom_wish|page_url|location/i.test(key)) return;
      var value = payload[key];
      if (typeof value === 'boolean') out[key] = value;
      else if (typeof value === 'number' && isFinite(value)) out[key] = value;
      else if (typeof value === 'string') out[key] = value.slice(0, 120);
    });
    return out;
  }

  function timelineBody(events) {
    return JSON.stringify({
      sessionId: P.designer_session_id,
      journeyId: timelineJourneyId,
      pageInstanceId: timelinePageInstanceId,
      events: events
    });
  }

  function flushTimeline(useBeacon) {
    if (!timelineQueue.length || !consentOK()) return;
    if (timelineTimer) {
      clearTimeout(timelineTimer);
      timelineTimer = 0;
    }
    var batch = timelineQueue.splice(0, 25);
    var body = timelineBody(batch);
    if (useBeacon && navigator.sendBeacon) {
      try {
        if (navigator.sendBeacon(TIMELINE_URL, new Blob([body], { type: 'application/json' }))) {
          if (timelineQueue.length) timelineTimer = setTimeout(flushTimeline, 5000);
          return;
        }
      } catch (e) {}
    }
    fetch(TIMELINE_URL, {
      method: 'POST',
      credentials: 'same-origin',
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: body
    }).then(function (response) {
      if (!response.ok) {
        var error = new Error('timeline ' + response.status);
        error.retryable = response.status === 408
          || response.status === 429
          || response.status >= 500;
        throw error;
      }
      if (timelineQueue.length) timelineTimer = setTimeout(flushTimeline, 5000);
    }).catch(function (error) {
      if (error && error.retryable === false) {
        if (DEBUG) console.warn('[iwa] timeline batch rejected', error.message);
        if (timelineQueue.length && !timelineTimer) {
          timelineTimer = setTimeout(flushTimeline, 5000);
        }
        return;
      }
      timelineQueue = batch.concat(timelineQueue).slice(0, 100);
      if (!timelineTimer) timelineTimer = setTimeout(flushTimeline, 10000);
    });
  }

  function queueTimeline(name, payload) {
    if (name.indexOf('designer_') !== 0 || !consentOK()) return;
    timelineSequence += 1;
    timelineQueue.push({
      eventId: 'te_' + Date.now().toString(36) + '_' + timelineSequence.toString(36) +
        '_' + Math.random().toString(36).slice(2, 7),
      name: name,
      sequence: timelineSequence,
      occurredAt: new Date().toISOString(),
      designId: boundDesignId || null,
      params: timelineParams(payload)
    });
    if (timelineQueue.length >= 10) flushTimeline(false);
    else if (!timelineTimer) timelineTimer = setTimeout(flushTimeline, 5000);
    if (
      name === 'designer_template_select' ||
      name === 'designer_start_blank' ||
      name === 'designer_template_list_error' ||
      name === 'designer_template_list_exit_summary' ||
      name === 'designer_review_success' ||
      name === 'designer_exit_summary'
    ) flushTimeline(true);
  }

  function track(name, params) {
    if (!consentOK()) return;
    var payload = Object.assign({}, P, params || {});
    if (DEBUG) console.log('[iwa]', name, payload);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, payload));
    if (GA4_ID && typeof window.gtag === 'function') {
      window.gtag('event', name, Object.assign({ transport_type: 'beacon' }, payload));
    }
    try {
      if (
        window.Shopify &&
        window.Shopify.analytics &&
        typeof window.Shopify.analytics.publish === 'function'
      ) {
        window.Shopify.analytics.publish('iwobbl_' + name, payload);
      }
    } catch (e) {}
    queueTimeline(name, payload);
  }

  window.IWAnalytics = {
    track: track,
    flush: flushTimeline,
    setDesignId: function (designId) {
      var value = String(designId || '');
      boundDesignId = /^d_[a-zA-Z0-9_-]+$/.test(value) ? value.slice(0, 128) : '';
    },
    consentOK: consentOK,
    debug: DEBUG,
    pageType: 'designer'
  };
  loadGtag();
  document.addEventListener('visitorConsentCollected', loadGtag);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') flushTimeline(true);
  });
  window.addEventListener('pagehide', function () { flushTimeline(true); });
  window.dispatchEvent(new CustomEvent('iwobbl:analytics-ready'));
  if (DEBUG) console.log('[iwa] designer analytics ready', P);
})();
